import { FILTER_TYPES } from 'components/FilterPod';
export const STATUS_BRANCH_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];

const reportNames = [
  {
    value: 'IMPREST_TRANSACTIONS',
    label: 'گزارش صورت حساب تنخواه گردان',
  },
  {
    value: 'ALL_FUNDER_IMPREST_XLS',
    label: 'گزارش کل تنخواه با فرمت xls',
  },
  {
    value: 'ALL_FUNDER_IMPREST_PDF',
    label: 'گزارش کل تنخواه با فرمت pdf',
  },
  {
    value: 'WALLET_GUILD',
    label: 'گزارش صورت حساب تلفیقی',
  },
  {
    value: 'CONTACT',
    label: 'گزارش انتقال وجه گروهی',
  },
  {
    value: 'WALLET_TRANSACTION_OVER_YEAR',
    label: 'گزارش صورت حساب دیجیتال بیش از یک سال',
  },

  {
    value: 'WALLET_TRANSACTION_THREE_MONTH',
    label: 'گزارش صورت حساب دیجیتال سه ماهه در بازه یک سال',
  },
  {
    value: 'GUILD_TRANSACTION_OVER_YEAR',
    label: 'گزارش صورت حساب تفصیلی بیش از یک سال',
  },
  {
    value: 'GUILD_TRANSACTION_THREE_MONTH',
    label: 'گزارش صورت حساب تفصیلی سه ماهه در بازه یک سال',
  },

  {
    value: 'DIGITAL_LIVE_TRANSACTION',
    label: 'گزارش صورتحساب دیجیتال دو ماهه',
  },
  {
    value: 'DIGITAL_DELAY_TRANSACTION',
    label: 'گزارش صورتحساب دیجیتال یک ساله',
  },
  {
    value: 'GUILD_LIVE_TRANSACTION',
    label: 'گزارش صورتحساب تفصیلی دو ماهه',
  },
  {
    value: 'GUILD_DELAY_TRANSACTION',
    label: 'گزارش صورتحساب تفصیلی یک ساله',
  },
  {
    value: 'BRANCH_LIVE_TRANSACTION',
    label: 'گزارش صورتحساب شعبه دو ماهه',
  },
  {
    value: 'BRANCH_DELAY_TRANSACTION',
    label: 'گزارش صورتحساب شعبه یک ساله',
  },
  {
    value: 'IMPREST_LIVE_TRANSACTION',
    label: 'گزارش صورتحساب تنخواه گردان دو ماهه',
  },
  {
    value: 'IMPREST_DELAY_TRANSACTION',
    label: 'گزارش صورتحساب تنخواه گردان یک ساله',
  },
  {
    value: 'SALES_INVOICE',
    label: ' گزارش فاکتورهای فروش  ',
  },
  {
    value: 'PURCHASE_INVOICE',
    label: ' گزارش فاکتورهای خرید  ',
  },
  {
    value: 'SETTLEMENTWALLET',
    label: 'گزارش درخواست های تسویه حساب دیجیتال',
  },
  {
    value: 'SETTLEMENTGUILD',
    label: 'گزارش درخواست های تسویه حساب تفصیلی',
  },
  {
    value: 'IMPREST_LIST',
    label: ' گزارش لیست تنخواه گردان  ',
  }, 
  {
    value: 'IMPREST_AGGREGATE',
    label: 'گزارش تجمیعی تنخواه',
  },
  {
    value: 'ASSIGNED_DELEGATION',
    label: 'گزارش وجه‌های تفویض شده به سایرین ',
  },
  {
    value: 'RECEIVED_DELEGATION',
    label: 'گزارش وجه‌های تفویض شده به من ',
  },
  {
    value: 'IMPREST_DEPOSIT_TWO_MONTHS',
    label: 'گزارش شارژ تنخواه دوماهه',
  },
  {
    value: 'IMPREST_DEPOSIT_ONE_YEAR',
    label: 'گزارش شارژ تنخواه یکساله',
  },
  {
    value: 'VOUCHER_LIST',
    label: 'گزارش بن تخفیف',
  },
];
/**
 * یک رشته دریافت میکند و آن را به حروف بزرگ تبدیل میکند
 */
const convertToUpperCase = (str) => {
  if (!str) return '';
  return String(str).trim().toUpperCase();
};
/**
 * برااساس پارامتری که توی آدرس بار ارسال شده است ، فیلتر نام گزارش متناسب با آن را انتخاب میکند
 */
const getFilterSourcePage = (page) => {
  let p = convertToUpperCase(page);
  let options = [];
  switch (p) {
    case 'TRANSACTIONSWALLET':
    case 'TRANSACTIONSWALLETIMPREST':
      options = [
        {
          value: 'WALLET_TRANSACTION_OVER_YEAR',
          label: 'گزارش صورت حساب دیجیتال بیش از یک سال',
        },
        {
          value: 'WALLET_TRANSACTION_THREE_MONTH',
          label: 'گزارش صورت حساب دیجیتال سه ماهه در بازه یک سال',
        },
        {
          value: 'DIGITAL_LIVE_TRANSACTION',
          label: 'گزارش صورتحساب دیجیتال دو ماهه',
        },
        {
          value: 'DIGITAL_DELAY_TRANSACTION',
          label: 'گزارش صورتحساب دیجیتال یک ساله',
        },
      ];
      break;

    case 'TRANSACTIONSGUILD':
    case 'TRANSACTIONSGUILDWITHID':
      options = [
        {
          value: 'GUILD_TRANSACTION_OVER_YEAR',
          label: 'گزارش صورت حساب تفصیلی بیش از یک سال',
        },
        {
          value: 'GUILD_TRANSACTION_THREE_MONTH',
          label: 'گزارش صورت حساب تفصیلی سه ماهه در بازه یک سال',
        },
        {
          value: 'GUILD_LIVE_TRANSACTION',
          label: 'گزارش صورتحساب تفصیلی دو ماهه',
        },
        {
          value: 'GUILD_DELAY_TRANSACTION',
          label: 'گزارش صورتحساب تفصیلی یک ساله',
        },
      ];
      break;
    case 'REPORTSUMMARY':
      options = [
        {
          value: 'IMPREST_AGGREGATE',
          label: 'گزارش تجمیعی تنخواه',
        },
      ];
      break;
    case 'INVOICE':
      options = [
        {
          value: 'SALES_INVOICE',
          label: ' گزارش فاکتورهای فروش  ',
        },
      ];
      break;
    case 'INVOICECREDITOR':
      options = [
        {
          value: 'PURCHASE_INVOICE',
          label: ' گزارش فاکتورهای خرید  ',
        },
      ];
      break;

    case 'IMPRESTLIST':
      options = [
        {
          value: 'IMPREST_LIST',
          label: 'گزارش لیست تنخواه گردان ',
        },
      ];
      break;

    case 'GROUPTRANSFERCREDIT':
      options = [
        {
          value: 'CONTACT',
          label: 'گزارش انتقال وجه گروهی',
        },
      ];
      break;
    case 'SETTLEMENTWALLET':
    case 'SETTLEMENTWALLETIMPREST':
      options = [
        {
          value: 'DIGITAL_SETTLEMENT',
          label: 'گزارش درخواست های تسویه حساب دیجیتال',
        },
      ];
      break;
    case 'DELEGATIONLIST':
      options = [
        {
          value: 'ASSIGNED_DELEGATION',
          label: 'گزارش وجه‌های تفویض شده به سایرین ',
        },
      ];
      break;

    case 'SETTLEMENTGUILD':
    case 'SETTLEMENTGUILDWITHID':
      options = [
        {
          value: 'GUILD_SETTLEMENT',
          label: 'گزارش درخواست های تسویه حساب تفصیلی',
        },
      ];
      break;

    case 'DELEGATION':
      options = [
        {
          value: 'RECEIVED_DELEGATION',
          label: 'گزارش وجه‌های تفویض شده به من ',
        },
      ];
      break;

    case 'FUNDERIMPRESTREPORT':
      options = [
        {
          value: 'ALL_FUNDER_IMPREST_XLS',
          label: 'گزارش کل تنخواه با فرمت xls',
        },
        {
          value: 'ALL_FUNDER_IMPREST_PDF',
          label: 'گزارش کل تنخواه با فرمت pdf',
        },
      ];
      break;
    case 'BRANCHTRANSACTIONS':
    case 'BRANCHTRANSACTIONSWITHID':
      options = [
        {
          value: 'IMPREST_TRANSACTIONS',
          label: 'گزارش صورت حساب تنخواه گردان',
        },
        {
          value: 'BRANCH_LIVE_TRANSACTION',
          label: 'گزارش صورتحساب شعبه دو ماهه',
        },
        {
          value: 'BRANCH_DELAY_TRANSACTION',
          label: 'گزارش صورتحساب شعبه یک ساله',
        },
      ];
      break;
    case 'WALLETANDGUILD':
      options = [
        {
          value: 'WALLET_GUILD',
          label: 'گزارش صورت حساب تلفیقی',
        },
      ];
      break;

    case 'IMPRESTTRANSACTIONS':
    case 'IMPRESTTRANSACTIONSWITHID':
      options = [
        {
          value: 'IMPREST_TRANSACTIONS',
          label: 'گزارش صورت حساب تنخواه گردان',
        },
        {
          value: 'IMPREST_LIVE_TRANSACTION',
          label: 'گزارش صورتحساب تنخواه گردان دو ماهه',
        },
        {
          value: 'IMPREST_DELAY_TRANSACTION',
          label: 'گزارش صورتحساب تنخواه گردان یک ساله',
        },
      ];
      break;

    case 'IMPRESTDEPOSITREPORT':
      options = [
        {
          value: 'IMPREST_DEPOSIT_TWO_MONTHS',
          label: 'گزارش شارژ تنخواه دوماهه',
        },
        {
          value: 'IMPREST_DEPOSIT_ONE_YEAR',
          label: 'گزارش شارژ تنخواه یکساله',
        },
      ];
      break;

    case 'VOUCHER':
      options = [
        {
          value: 'VOUCHER_LIST',
          label: 'گزارش بن تخفیف',
        }
      ];
      break;
    default:
      options = reportNames;
  }

  return options;
};

const filters = (reportPage) => [
  {
    title: 'نام گزارش',
    label: 'نام گزارش',
    keyName: 'reportKeys',
    query: 'reportKeys',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: getFilterSourcePage(reportPage),
    },
  },

  {
    title: 'بازه درخواست گزارش',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: false,
  },

  {
    title: 'وضعیت آماده سازی',
    label: 'وضعیت آماده سازی',
    keyName: 'reportStatusKeys',
    query: 'reportStatusKeys',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'TO_DO',
          label: 'در انتظار پردازش',
        },
        {
          value: 'DOING',
          label: 'در حال پردازش',
        },
        {
          value: 'DONE',
          label: 'پردازش شده',
        },
        {
          value: 'FAILED',
          label: 'خطا',
        },
      ],
    },
  },
];

export default filters;
